import './App.css';
import Header from './components/header/header';
import Home from './components/Home/Home';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Services from './components/Services/Services';
import Qualification from './components/Qualification/Qualification';
import Work from './components/Work/Work';
import Contact from './components/Contact/Contact';
import Footer from './components/footer/Footer';


;
function App() {
  return (

    <>
      <Header />
      <main className='main'>
        <Home />
        <About />
        <Skills />
        <Services />
        <Qualification />
        <Work />
        <Contact />
      </main>
      <Footer />

    </>
  );
}

export default App;